<div class="stepBlock">
  <p-steps
    [model]="MenuItem"
    [readonly]="true"
    [activeIndex]="activeIndex"
    (activeIndexChange)="onActiveIndexChange($event)"
  ></p-steps>
</div>
